@if (soundSrc()) {
  <audio #audioPlayer [src]="soundSrc()" preload="auto"></audio>
}

@if (show()) {
  <div class="announcement-balloon">
    <div class="announcement-caret"></div>
    <span class="announcement-badge">
      <i class="fa-solid fa-sparkles"></i>
      <span class="badge-text">{{ badgeText() }}</span>
    </span>
    <span class="badge-shine"></span>
    <h4 class="announcement-title">{{ title() }}</h4>
    <p class="announcement-text" [innerHTML]="description()"></p>
    <div class="announcement-actions">
      <button class="btn btn-primary btn-rounded announcement-btn-whatsapp" (click)="goToWhatsApp()">
        <i class="fa-brands fa-whatsapp"></i>
        Saiba Mais
      </button>
      <button class="btn btn-primary btn-rounded announcement-btn-ok" (click)="dismiss()">Entendi!</button>
    </div>
  </div>
}
